export const getVideoLoopUrl = (urlLoop,video) => {
    if(urlLoop?.url) {
        return {    
            url: `https://cdn.jwplayer.com/v2/media/${urlLoop.entityId}`,
            entityId: urlLoop.entityId,
            videoName: urlLoop.videoName,
            poster: `https://cdn.jwplayer.com/v2/media/${urlLoop.entityId}/poster.mp4?width=320`,
            videoLoop: true
        };
    } 

    if(video?.entityId) {
        return {
            poster: `https://cdn.jwplayer.com/v2/media/${video.entityId}/poster.mp4?width=320`,
            entityId: video.entityId,
            videoLoop: false

        }
    } 
}